'use client';
import { Typography } from '@mui/material';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  const errorHeadline = t('errorPage.404.headline');

  return (
    <Typography color="textPrimary" gutterBottom variant="h1">
      {errorHeadline}
      <p>Der Inhalt konnte nicht gefunden werden.</p>
      <Link href="/">Zu meinen Kursen</Link>
    </Typography>
  );
}
